import React, { useEffect, useState } from 'react'
import { OrderTypeControl, useLanguage, useOrder } from '~components'
import { Option, SelectedOption, ContentOption, ToggleOption, ToggleWrapper } from './styles'

const OrderTypeSelectorHeaderUI = (props) => {
  const {
    orderTypes,
    handleChangeOrderType
  } = props

  const [selected, setSelected] = useState(null)
  const [orderState] = useOrder()
  const handleToggle = (value) => {
    setSelected(value)
    handleChangeOrderType(value)
  }
  useEffect(() => {
    setSelected(orderState?.options?.type)
  }, [orderState?.options?.type])
  console.log(orderState?.options)
  return (
   <ToggleWrapper>
      {orderTypes.map(type => (
        <ToggleOption
          key={type.value}
          active={selected === type.value}
          onClick={() => handleToggle(type.value)}
          aria-pressed={selected === type.value}
        >
          {type.content}
        </ToggleOption>
      ))}
    </ToggleWrapper>
  )
}

export const OrderTypeSelectorHeader = (props) => {
  const [, t] = useLanguage()

  const orderTypeProps = {
    ...props,
    UIComponent: OrderTypeSelectorHeaderUI,
    orderTypes: props.orderTypes || [
      {
        value: 1,
        content: <Option><ContentOption>{t('DELIVERY', 'Delivery')}</ContentOption></Option>,
        showOnSelected: <Option><SelectedOption>{t('DELIVERY', 'Delivery')}</SelectedOption></Option>
      },
      {
        value: 2,
        content: <Option><ContentOption>{t('PICKUP', 'Pickup')}</ContentOption></Option>,
        showOnSelected: <Option><SelectedOption>{t('PICKUP', 'Pickup')}</SelectedOption></Option>
      }
    ]
  }

  return <OrderTypeControl {...orderTypeProps} />
}
